import { Controller } from "@hotwired/stimulus"

// MS50 #3003 — CSP-safe "Go Back" navigation.
//
// Replaces the inline `onclick="if (history.length > 1) { history.back(); }
// else { window.location.href = '/'; }"` handler the enforcing nonce CSP (#1222)
// blocked on the branded error pages. Wire with `data-controller="history-back"`
// and `data-action="click->history-back#back"`.
export default class extends Controller {
  back(event) {
    event.preventDefault()

    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = "/"
    }
  }
}
